import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../context/GlobalContext";
import Progress from "../Progress/Progress";
import CardButtonLeftArrow from "../../../assets/CardButtonLeftArrow.svg";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import DeliveryAddress from "./DeliveryAddress";

function DeliveryDetails({ rtl }: any) {
  const { t } = useTranslation();
  const [dispatch]: any = useContext(GlobalContext);
  let DeliveryDescription = t("Deliver_Details_Description");
  const dir = rtl ? "right" : "left";

  const handleBack = () => {
    dispatch({
      type: "SET_BACK_BUTTON",
      payload: { page: t("Product_Information") },
    });
  };
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 d-flex">
            <div className={`back-icon-container ${dir}`} onClick={handleBack}>
              <img
                className={`back-icon`}
                src={CardButtonLeftArrow}
                alt="arrow"
              />
            </div>
            <Progress rtl={rtl} title={t("Delivery_Details")} />
          </div>
          <div
            className={`col-sm-12 upload-attachment-container da-${dir} order-detail-popup`}
          >
            <div className="ProductInformation__headerSection flex-column-reverse-mobile">
              <div
                className={`product-information-text-container text-container-${dir} col-sm-8`}
              >
                <Typography rtl={rtl} className="form-title">
                  {t("Delivery_Details")}
                </Typography>
                <Typography rtl={rtl} className="product-information-text">
                  {DeliveryDescription}
                </Typography>
              </div>
            </div>
            <DeliveryAddress />
          </div>
        </div>
      </div>
    </>
  );
}

export default DeliveryDetails;
